var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class2, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import ModelTraits from "../ModelTraits";
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import ImageryProviderTraits from "./ImageryProviderTraits";
import LayerOrderingTraits from "./LayerOrderingTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import MappableTraits from "./MappableTraits";
import UrlTraits from "./UrlTraits";
export let CogRenderOptionsTraits = (_dec = primitiveTrait({
  type: "number",
  name: "No Data Value",
  description: "No data value, default read from tiff meta"
}), _dec2 = primitiveTrait({
  type: "boolean",
  name: "Convert to RGB",
  description: "Try to render multi band cog to RGB, priority 1"
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Resample Method",
  description: "Geotiff resample method. Defaults to `bilinear`."
}), _class = class CogRenderOptionsTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "nodata", _descriptor, this);
    _initializerDefineProperty(this, "convertToRGB", _descriptor2, this);
    _initializerDefineProperty(this, "resampleMethod", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "nodata", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "convertToRGB", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "resampleMethod", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "nearest";
  }
}), _class);
let CogCatalogItemTraits = (_dec4 = traitClass({
  description: "Creates a Cloud Optimised Geotiff item in the catalog from a url pointing to a TIFF that is a valid COG.",
  example: {
    name: "COG Test Uluru",
    description: "This is a COG from Sentinel-2 L2A, in EPSG:32752. Does it display in correct location? Does it display correctly?",
    type: "cog",
    url: "https://sentinel-cogs.s3.us-west-2.amazonaws.com/sentinel-s2-l2a-cogs/52/J/FS/2023/5/S2A_52JFS_20230501_0_L2A/TCI.tif"
  }
}), _dec5 = objectTrait({
  type: CogRenderOptionsTraits,
  name: "Render Options",
  description: "Render options for COGs"
}), _dec6 = primitiveTrait({
  type: "string",
  name: "Credit",
  description: "Credit for the imagery provider."
}), _dec7 = primitiveTrait({
  type: "number",
  name: "Tile Size",
  description: "The size of the tile."
}), _dec8 = primitiveTrait({
  type: "boolean",
  name: "Has Alpha Channel",
  description: "Whether the imagery has an alpha channel."
}), _dec9 = primitiveTrait({
  type: "number",
  name: "Cache",
  description: "Cache survival time in milliseconds."
}), _dec4(_class2 = (_class3 = class CogCatalogItemTraits extends mixTraits(ImageryProviderTraits, LayerOrderingTraits, UrlTraits, MappableTraits, CatalogMemberTraits, LegendOwnerTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "renderOptions", _descriptor4, this);
    _initializerDefineProperty(this, "credit", _descriptor5, this);
    _initializerDefineProperty(this, "tileSize", _descriptor6, this);
    _initializerDefineProperty(this, "hasAlphaChannel", _descriptor7, this);
    _initializerDefineProperty(this, "cache", _descriptor8, this);
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, "renderOptions", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "credit", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "tileSize", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "hasAlphaChannel", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, "cache", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3)) || _class2);
export { CogCatalogItemTraits as default };